module.exports = __webpack_public_path__ + "static/media/touch_icon_two.8f9ef797.svg";